import styled from "styled-components";

export const Current = styled.div`
  display: flex;
  align-items: center;
`;

export const Temp = styled.span`
  ${({ theme: { colors } }) => `
  font-size: 8vw;
  font-weight: 600;
  color: ${colors("text")};
    `}
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;
`;

export const Forecast = styled.div`
  display: flex;
`;

export const Day = styled.div`
  font-size: 1.1vw;
  margin: 0.5rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:first-child {
    margin-left: none;
  }
  &:last-child {
    margin-right: none;
  }
`;

export const Max = styled.span`
  font-weight: 600;
  font-size: 1.5vw;
`;

export const Empty = styled.div`
  font-size: 1.5vw;
  font-style: oblique;
  ${({ theme: { colors } }) => `
    color: ${colors("neutral")};
  `}
`;
